import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthComponent';
import { useNavigate } from 'react-router-dom';
import {
  Page, Card, ResourceList, ResourceItem, Text, BlockStack, Badge, Spinner, Box,
} from '@shopify/polaris';
import { api } from './apiClient';

export default function Uploads() {
  const { nameOf } = useAuth();
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.uploads().then(setRows).catch(() => setRows([])); }, []);

  return (
    <Page title="Upload history" backAction={{ onAction: () => nav('/adidas-map') }}>
      <Card>
        {!rows ? <Box padding="800"><Spinner accessibilityLabel="Loading" /></Box>
          : (
            <ResourceList
              items={rows}
              renderItem={(r) => (
                <ResourceItem id={String(r.id)} accessibilityLabel={r.filename_xlsm} onClick={() => {}}>
                  <BlockStack gap="100">
                    <Text as="p" variant="bodyMd" fontWeight="semibold">
                      {r.filename_xlsm} {r.applied_at
                        ? <Badge tone="success">applied</Badge>
                        : <Badge tone="attention">not applied</Badge>}
                    </Text>
                    <Text as="p" variant="bodySm" tone="subdued">
                      uploaded {r.uploaded_at} {r.applied_at && `· applied ${r.applied_at} by ${nameOf(r.applied_by)}`}
                    </Text>
                    <Text as="p" variant="bodySm" tone="subdued">
                      {r.season} · {r.sku_count} SKUs · {r.rows_pricing} pricing rows · {r.rows_upcs} UPCs
                    </Text>
                  </BlockStack>
                </ResourceItem>
              )}
            />
          )}
      </Card>
    </Page>
  );
}
